import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArticoloComponent } from './articolo/articolo.component';
import {RouterModule, Routes} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";
import {NgbModalModule} from "@ng-bootstrap/ng-bootstrap";
import { ArticoliModalComponent } from './articoli-modal/articoli-modal.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { QrPageComponent } from './qr-page/qr-page.component';

const routes: Routes = [
  {
    path: 'emendamento',
    component: ArticoloComponent,
  },
  {
    path: '',
    component: QrPageComponent,
  },
];

@NgModule({
  declarations: [
    ArticoloComponent,
    ArticoliModalComponent,
    QrPageComponent
  ],
  imports: [
    SlickCarouselModule,
    CommonModule,
    RouterModule.forChild(routes),
    TranslateModule,
    NgbModalModule,
  ]
})
export class CameraModule { }
